module.exports = __webpack_public_path__ + "img/20190809161705821.541bf5ba.png";